export default "__VITE_ASSET__CGOWcXIc__"